
import './pwa';
import './i18n';

import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { BUILD, DEVICE, IS_LOCALHOST, LS_DARK_MODE, SENTRY_DSN } from './config';
import { applyPolyfills } from './polyfills';

console.log('Build', BUILD);

const initSentry = async () => {
  if (SENTRY_DSN) {
    const Sentry = await import("@sentry/react");
    const { BrowserTracing } = await import("@sentry/tracing");

    Sentry.init({
      release: BUILD,
      dsn: SENTRY_DSN,
      integrations: [new BrowserTracing()],
      tracesSampleRate: 0,
      ignoreErrors: [
        'Non-Error exception captured'
      ]
    });
  }
}

// Theme support
document.body.className = localStorage.getItem(LS_DARK_MODE) === 'DARK' ? 'dark' : 'light';

// Init Sentry
initSentry();

// Apply polyfill, then init the app
applyPolyfills().then(() => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<React.StrictMode>
    <App />
  </React.StrictMode>);
})

// Register service worker
if ('serviceWorker' in navigator && ['WEB', 'PWA'].includes(DEVICE) && !IS_LOCALHOST) {
  const path = '/sw.js'; // Should use variable to avoid auto detection by Parcel
  navigator.serviceWorker.register(path, { type: 'module' }).catch(console.error);
}
